import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/index';
import { useSidebar } from '../contexts/SidebarContext';
import { useNewGui } from '../hooks/useNewGui';
import PageHeader from '../components/shared/PageHeader';
import { FiMail, FiKey } from 'react-icons/fi';

const UserProfile: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const { isSidebarOpen } = useSidebar();
  const useNew = useNewGui();

  if (useNew) {
    const initial = user?.email ? user.email.charAt(0).toUpperCase() : '?';
    return (
      <div className={`flex-1 p-6 font-plex transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-20'}`}>
        <PageHeader title="My Profile" purpose="Your account details." />
        {user ? (
          <div className="bg-surface border border-border-subtle rounded-lg shadow-sm max-w-md p-6">
            <div className="flex items-center gap-4 mb-5">
              <div className="w-14 h-14 rounded-full bg-accent/15 text-accent flex items-center justify-center text-xl font-semibold flex-shrink-0">
                {initial}
              </div>
              <div className="min-w-0">
                <div className="text-base font-semibold text-ink-primary truncate">{user.email}</div>
                <div className="text-xs text-ink-secondary">{user.role}</div>
              </div>
            </div>
            <div className="space-y-3 pt-4 border-t border-border-subtle">
              <div className="flex items-center gap-3">
                <FiMail className="text-accent flex-shrink-0" />
                <div>
                  <div className="text-xs text-ink-secondary">Email</div>
                  <div className="text-sm text-ink-primary">{user.email}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <FiKey className="text-accent flex-shrink-0" />
                <div>
                  <div className="text-xs text-ink-secondary">Login method</div>
                  <div className="text-sm text-ink-primary">{user.method}</div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="bg-surface border border-border-subtle rounded-lg p-6 max-w-md text-sm text-ink-secondary">
            Not logged in.
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`p-4 ${isSidebarOpen ? 'ml-64' : 'ml-16'} transition-all`}>
      <h1 className="text-2xl font-bold mb-4 text-center">My profile details </h1>

        <h2 className="font-bold mb-4 text-center">{user? user.email : "(Not logged in)" }</h2>

        <div className="text-black relative">
            {user ? (
            <div className="flex items-center">
                <div>
                <span>email: {user.email}</span>
                </div>
                <div>
                <span>Method: {user.method}</span>
                </div>
            </div>
            ) : (
            <div>
                User Not logged on
                (The functionality of this page needs to be enhanced to remain relevant on refresh, include last few user operations, joining date etc)
            </div>
            )}
        </div>

    </div>
  );
};

export default UserProfile;
